// hooks/useEventSlotFetchData.js
import { useState, useEffect } from "react";
import { userService } from "../services/userService.js";
import { managementService } from "../services/managementService.js";

/**
 * Hook centralisé pour fetch toutes les données nécessaires au formulaire
 */
export function useEventSlotFetchData(slotId = null, eventId = null) {
  const [data, setData] = useState({
    teachers: [],
    allUsers: [],
    recurrences: [], // Toutes les récurrences de l'événement
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        // Charger en parallèle
        const promises = [userService.getTeachers(), userService.getAll()];

        // Ajouter la récurrence seulement si on a un eventId
        if (eventId) {
          promises.push(managementService.getAllRecurrences(eventId));
        }

        const results = await Promise.all(promises);

        setData({
          teachers: results[0],
          allUsers: results[1],
          recurrences: eventId ? results[2] : [],
        });
      } catch (err) {
        setError(err.message);
        console.error("Erreur chargement données:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [slotId, eventId]);

  return { data, loading, error };
}
